export const radius = {
  regular: "8px",
};
